import React from 'react';
import { EnvelopeIcon, ArrowTopRightOnSquareIcon, PhoneIcon } from '@heroicons/react/24/outline';
import avatar from '../../../assets/images/avatar.svg';
import Card from '../../components/Card';

export default function StewardContact(props) {
  const { networkSupportQuestion } = props;

  return (
    <Card>
      {/*<div className="p-6 space-y-6">*/}
      <div className="flex flex-col sm:flex-row px-4 py-3 space-x-0 sm:space-x-4 space-y-2 sm:space-y-0">
        <div className="flex h-14 w-14">
          <img
            className="rounded-full object-center object-cover aspect-1"
            src={networkSupportQuestion.data.stewardAvatarUrl || avatar}
            alt=""
          />
        </div>
        <div className="flex-1 space-y-2">
          <div>
            <div className="text-lg font-semibold text-cs-gray-900">
              {networkSupportQuestion.data.stewardName}
            </div>
            <div className="text-sm text-cs-gray-500">
              {networkSupportQuestion.data.stewardDescription}
            </div>
          </div>
          <div className="flex flex-col md:flex-row space-y-1 space-x-0 md:space-y-0 md:space-x-4">
            {networkSupportQuestion.data.stewardEmail && (
              <div className="flex items-center space-x-1 text-cs-blue-500">
                <EnvelopeIcon className="h-5 w-5"/>
                <div className="flex-1">
                  <a className="block text-sm text-cs-blue-500" href={`mailto:${networkSupportQuestion.data.stewardEmail}`}>
                    {networkSupportQuestion.data.stewardEmail}
                  </a>
                </div>
              </div>
            )}
            {networkSupportQuestion.data.stewardPhone && (
              <div className="flex items-center space-x-1 text-cs-blue-500">
                <PhoneIcon className="h-5 w-5"/>
                <div className="flex-1">
                  <a className="block text-sm text-cs-blue-500" href={`tel:${networkSupportQuestion.data.stewardPhone}`}>
                    {networkSupportQuestion.data.stewardPhone}
                  </a>
                </div>
              </div>
            )}
            {networkSupportQuestion.data.stewardCustomUrl && (
              <div className="flex items-center space-x-1 text-cs-blue-500">
                <ArrowTopRightOnSquareIcon className="h-5 w-5"/>
                <div className="flex-1">
                  <a className="block text-sm text-cs-blue-500" target="_blank" href={networkSupportQuestion.data.stewardCustomUrl}>
                    {networkSupportQuestion.data.stewardCustomLabel || networkSupportQuestion.data.stewardCustomUrl}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
